var map = {
	"./CSRealCase1-en-moblie.jpg": 635,
	"./CSRealCase1-en.jpg": 636,
	"./CSRealCase1-moblie.jpg": 637,
	"./CSRealCase1.jpg": 638,
	"./CSRealCase2-en-moblie.jpg": 639,
	"./CSRealCase2-en.jpg": 640,
	"./CSRealCase2-moblie.jpg": 641,
	"./CSRealCase2.jpg": 642,
	"./CSRealCase3-en-moblie.jpg": 643,
	"./CSRealCase3-en.jpg": 644,
	"./CSRealCase3-moblie.jpg": 645,
	"./CSRealCase3.jpg": 646,
	"./CommonInternetWhalingAttacks1.jpg": 647,
	"./CommonInternetWhalingAttacks2.jpg": 648,
	"./CommonInternetWhalingAttacks3.jpg": 649,
	"./CommonInternetWhalingAttacks4.jpg": 650,
	"./CustomerRealCase1-en-moblie.jpg": 651,
	"./CustomerRealCase1-en.jpg": 652,
	"./CustomerRealCase1-moblie.jpg": 653,
	"./CustomerRealCase1.jpg": 654,
	"./E-commerceRealCase1-en.jpg": 655,
	"./E-commerceRealCase1-moblie-en.jpg": 656,
	"./E-commerceRealCase1-moblie.jpg": 657,
	"./E-commerceRealCase1.jpg": 658,
	"./E-commerceRealCase2-en.jpg": 659,
	"./E-commerceRealCase2-mobile.jpg": 660,
	"./E-commerceRealCase2-moblie-en.jpg": 661,
	"./E-commerceRealCase2-moblie.jpg": 662,
	"./E-commerceRealCase2.jpg": 663,
	"./FinanceRealCase-en.jpg": 664,
	"./FinanceRealCase-mobile-en.jpg": 665,
	"./FinanceRealCase-mobile-sc.jpg": 666,
	"./FinanceRealCase-mobile.jpg": 667,
	"./FinanceRealCase-sc.jpg": 668,
	"./FinanceRealCase.jpg": 669,
	"./FinanceRealCase2-en.jpg": 670,
	"./FinanceRealCase2-mobile-en.jpg": 671,
	"./FinanceRealCase2-mobile-sc.jpg": 672,
	"./FinanceRealCase2-mobile.jpg": 673,
	"./FinanceRealCase2-sc.jpg": 674,
	"./FinanceRealCase2.jpg": 675,
	"./HRRealCase-en.jpg": 676,
	"./HRRealCase-mobile-en.jpg": 677,
	"./HRRealCase-mobile.jpg": 678,
	"./HRRealCase.jpg": 679,
	"./ITRealCase1-en.jpg": 680,
	"./ITRealCase1-moblie-en.jpg": 681,
	"./ITRealCase1-moblie.jpg": 682,
	"./ITRealCase1.jpg": 683,
	"./ITRealCase2-en.jpg": 684,
	"./ITRealCase2-moblie-en.jpg": 685,
	"./ITRealCase2-moblie.jpg": 686,
	"./ITRealCase2.jpg": 687,
	"./ITRealCase3-en.jpg": 688,
	"./ITRealCase3-moblie-en.jpg": 689,
	"./ITRealCase3-moblie.jpg": 690,
	"./ITRealCase3.jpg": 691,
	"./IndexPrompt.jpg": 692,
	"./MarketRealCase.jpg": 693,
	"./MarketRealCase1-en-moblie.jpg": 694,
	"./MarketRealCase1-en.jpg": 695,
	"./MarketRealCase1-moblie.jpg": 696,
	"./MarketRealCase1.jpg": 697,
	"./MarketRealCase2-en-moblie.jpg": 698,
	"./MarketRealCase2-en.jpg": 699,
	"./MarketRealCase2-moblie.jpg": 700,
	"./MarketRealCase2.jpg": 701,
	"./MarketRealCase3-en.jpg": 702,
	"./NGORealCase1-en.jpg": 703,
	"./NGORealCase1-moblie-en.jpg": 704,
	"./NGORealCase1-moblie.jpg": 705,
	"./NGORealCase1.jpg": 706,
	"./NGORealCase2-en.jpg": 707,
	"./NGORealCase2-moblie-en.jpg": 708,
	"./NGORealCase2-moblie.jpg": 709,
	"./NGORealCase2.jpg": 710,
	"./RealCase-mobile-en.jpg": 711,
	"./RealCase-mobile-sc.jpg": 712,
	"./RealCase-sc.jpg": 713,
	"./RealCase.mobile.jpg": 714,
	"./Realcase-socialMedia-mobile.jpg": 715,
	"./Realcase-socialMedia.jpg": 716,
	"./a004-a.jpg": 717,
	"./a004-b.jpg": 718,
	"./a004-example1-en.jpg": 719,
	"./a004-example1-sc.jpg": 720,
	"./a004-example1.jpg": 721,
	"./a004-example2.jpg": 722,
	"./a004-example3.jpg": 723,
	"./a008-tip.jpg": 724,
	"./a009-tip1.jpg": 725,
	"./a009-tip2.jpg": 726,
	"./a009-tip3.jpg": 727,
	"./a011-01.jpg": 728,
	"./a011-010.jpg": 729,
	"./a011-011.jpg": 730,
	"./a011-012.jpg": 731,
	"./a011-02.jpg": 732,
	"./a011-03.jpg": 733,
	"./a011-04.jpg": 734,
	"./a011-05.jpg": 735,
	"./a011-06.jpg": 736,
	"./a011-07.jpg": 737,
	"./a011-08.jpg": 738,
	"./a011-09.jpg": 739,
	"./a011-example1.jpg": 740,
	"./a011-example2.jpg": 741,
	"./a011-example3.jpg": 742,
	"./a011-example5.jpg": 743,
	"./a011-example6.jpg": 744,
	"./a011-example7.jpg": 745,
	"./a011-example8.jpg": 746,
	"./a016-1.jpg": 747,
	"./a016-2.jpg": 748,
	"./a016-3.jpg": 749,
	"./a016-4.jpg": 750,
	"./a016-5.jpg": 751,
	"./a016-6.jpg": 752,
	"./a016-market-1.jpg": 753,
	"./a016-market-2.jpg": 754,
	"./a016-market-3.jpg": 755,
	"./a016-market-4.jpg": 756,
	"./a019-tip-en.jpg": 757,
	"./a019-tip.jpg": 758,
	"./a021-viewmore-en.jpg": 759,
	"./a021-viewmore-fsi.jpg": 760,
	"./a021-viewmore.jpg": 761,
	"./a023-short1.jpg": 275,
	"./a023-short2.jpg": 276,
	"./a023-short3.jpg": 277,
	"./a023-short4.jpg": 278,
	"./a023-short5.jpg": 279,
	"./a023-short6.jpg": 280,
	"./a026-example1.jpg": 800,
	"./a026-example2.jpg": 801,
	"./a026-example3.jpg": 802,
	"./a026-example4.jpg": 803,
	"./a026-example5.jpg": 804,
	"./a026-example6.jpg": 805,
	"./a026-example7.jpg": 806,
	"./a028-example1.jpg": 813,
	"./a028-example2.jpg": 814,
	"./a028-example3.jpg": 815,
	"./a037-a.jpg": 816,
	"./a037-b.jpg": 817,
	"./a037-c.jpg": 818,
	"./a037-d.jpg": 819,
	"./a037-e.jpg": 820,
	"./a037-f.jpg": 821,
	"./a037-g.jpg": 822,
	"./a037-h.jpg": 823,
	"./a037-i.jpg": 824,
	"./a037-j.jpg": 825,
	"./a037-k.jpg": 826,
	"./a037-l.jpg": 827,
	"./a037-m.jpg": 828,
	"./a037-n.jpg": 829,
	"./aiSecurityRealcase-en.jpg": 830,
	"./aiSecurityRealcase-mobile-en.jpg": 831,
	"./aiSecurityRealcase-mobile.jpg": 832,
	"./aiSecurityRealcase.jpg": 833,
	"./c001-E-commerce-1.jpg": 834,
	"./c001-E-commerce-2.jpg": 835,
	"./c001-E-commerce-3.jpg": 836,
	"./c001-E-commerce-4.jpg": 837,
	"./c001-E-commerce-5.jpg": 838,
	"./c001-E-commerce-6.jpg": 839,
	"./c001-Picture1.jpg": 840,
	"./c001-Picture2.jpg": 841,
	"./c001-Picture3.jpg": 842,
	"./c001-fsi-1.jpg": 843,
	"./c001-fsi-2.jpg": 844,
	"./c001-fsi-3.jpg": 845,
	"./c001-fsi-4.jpg": 846,
	"./c001-ngo-1.jpg": 847,
	"./c001-ngo-2.jpg": 848,
	"./c001-ngo-3.jpg": 849,
	"./c001-ngo-4.jpg": 850,
	"./c001-ngo-5.jpg": 851,
	"./c001-student-1.jpg": 852,
	"./c001-student-2.jpg": 853,
	"./c001-student-3.jpg": 854,
	"./c001-student-4.jpg": 855,
	"./c001-student-5.jpg": 856,
	"./c001-student-6.jpg": 857,
	"./c001-student-7.jpg": 858,
	"./c001-student-8.jpg": 859,
	"./c002-example1.jpg": 860,
	"./c002-general2024-example1.jpg": 861,
	"./c006-1.jpg": 862,
	"./c006-2.jpg": 863,
	"./c006-3.jpg": 864,
	"./c006-4.jpg": 865,
	"./c006-5.jpg": 866,
	"./c006-6.jpg": 867,
	"./c006-a.jpg": 868,
	"./c006-b.jpg": 869,
	"./c006-c.jpg": 870,
	"./c006-d.jpg": 871,
	"./c007-1.jpg": 872,
	"./c007-bg.jpg": 873,
	"./cert/cert-E-commerce-HKIRC.jpg": 874,
	"./cert/cert-E-commerce-consumer.jpg": 875,
	"./cert/cert-E-commerce-cpttm.jpg": 876,
	"./cert/cert-E-commerce-hkgcsmeaa.jpg": 281,
	"./cert/cert-customer-HKIRC.jpg": 877,
	"./cert/cert-customer-consumer.jpg": 878,
	"./cert/cert-customer-cpttm.jpg": 879,
	"./cert/cert-customer-hkgcsmeaa.jpg": 282,
	"./cert/cert-finance-HKIRC-sc.jpg": 880,
	"./cert/cert-finance-HKIRC.jpg": 881,
	"./cert/cert-finance-consumer-sc.jpg": 882,
	"./cert/cert-finance-consumer.jpg": 883,
	"./cert/cert-finance-cpttm-sc.jpg": 884,
	"./cert/cert-finance-cpttm.jpg": 885,
	"./cert/cert-finance-hkgcsmeaa-sc.jpg": 283,
	"./cert/cert-finance-hkgcsmeaa.jpg": 284,
	"./cert/cert-fsi-HKIRC-sc.jpg": 886,
	"./cert/cert-fsi-HKIRC.jpg": 887,
	"./cert/cert-fsi-consumer-sc.jpg": 888,
	"./cert/cert-fsi-consumer.jpg": 889,
	"./cert/cert-fsi-cpttm-sc.jpg": 890,
	"./cert/cert-fsi-cpttm.jpg": 891,
	"./cert/cert-fsi-hkgcsmeaa-sc.jpg": 285,
	"./cert/cert-fsi-hkgcsmeaa.jpg": 286,
	"./cert/cert-general-staff-HKIRC-sc.jpg": 892,
	"./cert/cert-general-staff-HKIRC.jpg": 893,
	"./cert/cert-general-staff-a-HKIRC-sc.jpg": 894,
	"./cert/cert-general-staff-a-HKIRC.jpg": 895,
	"./cert/cert-general-staff-a-consumer-sc.jpg": 896,
	"./cert/cert-general-staff-a-consumer.jpg": 897,
	"./cert/cert-general-staff-a-cpttm-sc.jpg": 898,
	"./cert/cert-general-staff-a-cpttm.jpg": 899,
	"./cert/cert-general-staff-a-hkgcsmeaa-sc.jpg": 287,
	"./cert/cert-general-staff-a-hkgcsmeaa.jpg": 288,
	"./cert/cert-general-staff-consumer-sc.jpg": 900,
	"./cert/cert-general-staff-consumer.jpg": 901,
	"./cert/cert-general-staff-cpttm-sc.jpg": 902,
	"./cert/cert-general-staff-cpttm.jpg": 903,
	"./cert/cert-general-staff-hkgcsmeaa-sc.jpg": 289,
	"./cert/cert-general-staff-hkgcsmeaa.jpg": 290,
	"./cert/cert-general2024-HKIRC-sc.jpg": 904,
	"./cert/cert-general2024-HKIRC.jpg": 905,
	"./cert/cert-general2024-consumer-sc.jpg": 906,
	"./cert/cert-general2024-consumer.jpg": 907,
	"./cert/cert-general2024-cpttm-sc.jpg": 908,
	"./cert/cert-general2024-cpttm.jpg": 909,
	"./cert/cert-general2024-hkgcsmeaa-sc.jpg": 219,
	"./cert/cert-general2024-hkgcsmeaa.jpg": 220,
	"./cert/cert-hr-HKIRC.jpg": 910,
	"./cert/cert-hr-consumer.jpg": 911,
	"./cert/cert-hr-cpttm.jpg": 912,
	"./cert/cert-hr-hkgcsmeaa.jpg": 291,
	"./cert/cert-it-HKIRC.jpg": 913,
	"./cert/cert-it-consumer.jpg": 914,
	"./cert/cert-it-cpttm.jpg": 915,
	"./cert/cert-it-hkgcsmeaa.jpg": 292,
	"./cert/cert-market-HKIRC.jpg": 916,
	"./cert/cert-market-consumer.jpg": 917,
	"./cert/cert-market-cpttm.jpg": 918,
	"./cert/cert-market-hkgcsmeaa.jpg": 293,
	"./cert/cert-ngo-HKIRC.jpg": 919,
	"./cert/cert-ngo-consumer.jpg": 920,
	"./cert/cert-ngo-cpttm.jpg": 921,
	"./cert/cert-ngo-hkgcsmeaa.jpg": 294,
	"./cert/cert-senior-manager-HKIRC-sc.jpg": 922,
	"./cert/cert-senior-manager-HKIRC.jpg": 923,
	"./cert/cert-senior-manager-consumer-sc.jpg": 924,
	"./cert/cert-senior-manager-consumer.jpg": 925,
	"./cert/cert-senior-manager-cpttm-sc.jpg": 926,
	"./cert/cert-senior-manager-cpttm.jpg": 927,
	"./cert/cert-senior-manager-hkgcsmeaa-sc.jpg": 295,
	"./cert/cert-senior-manager-hkgcsmeaa.jpg": 296,
	"./cert/cert-startup-HKIRC.jpg": 928,
	"./cert/cert-startup-consumer.jpg": 929,
	"./cert/cert-startup-cpttm.jpg": 930,
	"./cert/cert-startup-hkgcsmeaa.jpg": 297,
	"./cert/cert-student-HKIRC-sc.jpg": 931,
	"./cert/cert-student-HKIRC.jpg": 932,
	"./cert/cert-student-consumer-sc.jpg": 933,
	"./cert/cert-student-consumer.jpg": 934,
	"./cert/cert-student-cpttm-sc.jpg": 935,
	"./cert/cert-student-cpttm.jpg": 936,
	"./cert/cert-student-hkgcsmeaa-sc.jpg": 298,
	"./cert/cert-student-hkgcsmeaa.jpg": 299,
	"./dataLeakageRealcase-en.jpg": 937,
	"./dataLeakageRealcase-mobile-en.jpg": 938,
	"./dataLeakageRealcase-mobile.jpg": 939,
	"./dataLeakageRealcase.jpg": 940,
	"./education/topic1000/panelData4.jpg": 235,
	"./education/topic1000/panelData6.jpg": 236,
	"./fsiRealCase1-en.jpg": 941,
	"./fsiRealCase1-mobile-en.jpg": 942,
	"./fsiRealCase1-mobile-sc.jpg": 943,
	"./fsiRealCase1-mobile.jpg": 944,
	"./fsiRealCase1-sc.jpg": 945,
	"./fsiRealCase1.jpg": 946,
	"./fsiRealCase2-en-mobile.jpg": 947,
	"./fsiRealCase2-en.jpg": 948,
	"./fsiRealCase2-mobile-sc.jpg": 949,
	"./fsiRealCase2-mobile.jpg": 950,
	"./fsiRealCase2-sc.jpg": 951,
	"./fsiRealCase2.jpg": 952,
	"./general2024RealCase1-en-mobile.jpg": 953,
	"./general2024RealCase1-en.jpg": 954,
	"./general2024RealCase1-mobile-sc.jpg": 955,
	"./general2024RealCase1-mobile.jpg": 956,
	"./general2024RealCase1-sc.jpg": 957,
	"./general2024RealCase1.jpg": 958,
	"./it900-a031-en.jpg": 959,
	"./it900-a031.jpg": 960,
	"./it900-a32-1.jpg": 961,
	"./it900-a32-2.jpg": 962,
	"./it900-a32-3.jpg": 963,
	"./it930-a033-1.jpg": 964,
	"./it930-a033-2.jpg": 965,
	"./it930-a033-3.jpg": 966,
	"./it930-a033-4.jpg": 967,
	"./it930-a033-5-en.jpg": 968,
	"./it930-a033-5.jpg": 969,
	"./lady-right.jpg": 970,
	"./man-right.jpg": 971,
	"./man.jpg": 972,
	"./news-mobile-en.jpg": 973,
	"./news-mobile-sc.jpg": 974,
	"./news-mobile.jpg": 975,
	"./news-sc.jpg": 976,
	"./news.jpg": 977,
	"./ngo-a035-1.jpg": 978,
	"./ngo-a035-2.jpg": 979,
	"./ngo-a035-3.jpg": 980,
	"./ngo-a035-4.jpg": 981,
	"./ngo-a036-example.jpg": 982,
	"./p-onprogress-B.jpg": 983,
	"./s3-004.jpg": 984,
	"./s3-005.jpg": 985,
	"./s3-006.jpg": 986,
	"./s3-007.jpg": 987,
	"./s3-008.jpg": 988,
	"./startupRealCase1-en.jpg": 1020,
	"./startupRealCase1-mobile-en.jpg": 1021,
	"./startupRealCase1-mobile.jpg": 1022,
	"./startupRealCase1.jpg": 1023,
	"./startupRealCase2-en.jpg": 1024,
	"./startupRealCase2-mobile-en.jpg": 1025,
	"./startupRealCase2-mobile.jpg": 1026,
	"./startupRealCase2.jpg": 1027,
	"./studentRealCase1-mobile-sc.jpg": 1028,
	"./studentRealCase1-sc.jpg": 1029,
	"./studentRealCase2-mobile-sc.jpg": 1030,
	"./studentRealCase2-sc.jpg": 1031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3103;